export default __webpack_public_path__ + "static/media/instacart-dark.abf0bd1e.svg";